import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ClientService } from 'src/app/service/api';
import { AlertService, WarningService } from 'src/app/service/common';
import { NameValidator } from 'src/app/common/form-validator';
import { ValidClient } from 'src/app/common/interfaces/client.interface';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CLIENT_TYPE, REDIRECT_URL } from 'src/app/common/constant';

@Component({
  selector: 'client-migration',
  templateUrl: './client-migration.component.html',
  styleUrls: ['./client-migration.component.scss'],
})
export class ClientMigrationComponent implements OnInit {
  validClient = {} as ValidClient;
  formSubmitAttempt = false;
  addClientForm: FormGroup;
  successClientForm: FormGroup;
  redirectUrlForm: FormGroup;
  maxRedirectUrlLength = REDIRECT_URL.MAXLENGTH;
  redirectUrlLimit = REDIRECT_URL.LIMIT;
  migrateClientSuccessRef: MatDialogRef<any>;

  @ViewChild('migrateClientSuccess', { static: true })
  migrateClientSuccess: TemplateRef<any>;

  errorMessageTryAgain: string;

  @ViewChild('migrateClientTryAgain', { static: true })
  migrateClientTryAgain: TemplateRef<any>;

  constructor(
    protected clientService: ClientService,
    protected router: Router,
    protected fb: FormBuilder,
    protected alertService: AlertService,
    protected warningService: WarningService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.addClientForm = this.fb.group({
      client_id: this.fb.control('', [Validators.required, Validators.maxLength(32), NameValidator()]),
      client_secret: this.fb.control('', [Validators.required, Validators.maxLength(256), NameValidator()]),
    });
    this.successClientForm = this.fb.group({
      project_name: this.fb.control('', [Validators.required, Validators.maxLength(256)]),
    });

    this.redirectUrlForm = this.fb.group({
      redirect_url: this.fb.array([]),
    });
  }

  handleMigrateClient() {
    this.dialog.open(ClientMigrationComponent, {
      panelClass: 'client-migration',
      width: '580px',
      id: 'migrateClientModal',
      autoFocus: false,
      restoreFocus: false,
    });
  }

  handleTryAgain() {
    this.dialog.open(this.migrateClientTryAgain, {
      width: '580px',
      id: 'migrateClientTryAgain',
      autoFocus: false,
      restoreFocus: false,
      maxHeight: '90vh',
      panelClass: 'client-migration-tryagain',
    });
  }

  confirmAddClient() {
    if (!this.addClientForm.valid) {
      return;
    }
    this.clientService.validateMigrateClient(this.addClientForm.value).subscribe(
      ({ client_id, client_name, client_secrets, redirect_url, client_type }: any) => {
        this.validClient = {
          client_id,
          client_name,
          client_secret: client_secrets[0],
          redirect_url,
          client_type,
        };
        this.redirectUrlArray.markAsTouched();
        this.redirectUrlArray.updateValueAndValidity();

        this.closeAllModals();
        this.migrateClientSuccessRef = this.dialog.open(this.migrateClientSuccess, {
          width: '580px',
          id: 'migrateClientSuccess',
          autoFocus: false,
          restoreFocus: false,
          maxHeight: '90vh',
          panelClass: 'client-migration-success',
        });
        this.addClientForm.reset();
      },
      (err) => {
        this.closeAllModals();
        console.error(err);
        if (err.error.code == 'MIG001') {
          this.errorMessageTryAgain = err.error.message;
          this.handleTryAgain();
        } else if (err.error.code == 'MIG002' || err.error.code === 'MIG005') {
          this.warningService.push('Project already claimed', err.error.message || this.defaultErrorMessage);
        } else {
          this.warningService.push('There was an error', err.error.message || this.defaultErrorMessage);
        }
        this.formSubmitAttempt = false;
        this.addClientForm.reset();
      }
    );
  }

  get redirectUrlArray(): FormArray {
    return this.redirectUrlForm.controls.redirect_url as FormArray;
  }

  createProject() {
    if (!this.successClientForm.valid) {
      return;
    }
    if (this.migrateClientSuccessRef) this.migrateClientSuccessRef.close();
    this.validClient = { ...this.validClient, ...this.successClientForm.value, ...this.redirectUrlForm.value };
    this.clientService.migrateClient(this.validClient).subscribe(
      () => {
        this.successClientForm.reset();
        this.redirectUrlForm.reset();
        // go to client detail
        this.clientService.getMigrateClient(this.validClient.client_id).subscribe(
          (res: any) => {
            if (res && res.project_id) {
              this.router.navigate(['/project/all-type-project/' + res.project_id]);
            } else {
              this.router.navigate(['/project']);
            }
          },
          (err) => console.error(err)
        );
      },
      (err) => {
        this.closeAllModals();
        console.error(err);
        this.warningService.push('There was an error', err.error.message || this.defaultErrorMessage);
      }
    );
  }

  closeAllModals() {
    this.dialog.closeAll();
  }

  get defaultErrorMessage() {
    return 'Failed to retrieve information';
  }

  get isWeb(): boolean {
    return this.validClient.client_type === CLIENT_TYPE.WEB || this.validClient.client_type === 'NativeApp';
  }
}
